import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface TenantData {
  uuid: string;
  transcription_plan: string;
  transcription_enabled: boolean;
  status: string;
  speech_analytics_enabled: boolean;
  recording_type: string;
  rec_retension_period_value: string;
  rec_retension_period_type: string;
  other_info_map: Record<string, any>;
  name: string;
  is_timezone_restricted: boolean;
  is_softphone_enabled: boolean;
  is_sms_enabled: boolean;
  is_recordable: boolean;
  is_pbx_enabled: boolean;
  is_monitorable: boolean;
  is_migrated: boolean;
  is_dcid_enabled: boolean;
  is_ccs_enabled: boolean;
  ext_rec_licenses: number;
  displayname: string;
}

export interface CallRecord {
  uuid?: string;
  start_date?: string;
  start_time?: string;
  end_time?: string;
  origination_ts?: number;
  end_ts?: number;
  [key: string]: any;
}

export interface CallRecordsFilters {
  start_time?: number | string;
  end_time?: number | string;
  direction?: string;
  [key: string]: any;
}

export interface CallRecordsState {
  filters: CallRecordsFilters | null;
  searchtext: string;
  tableData: CallRecord[];
  pageCount: number;
  pageNumber: number;
  perPage: number;
  apiLoadingStatus: boolean;
  sortNode: string;
  sortOrder: string;
  tenantData: TenantData | null;
}

const initialState: CallRecordsState = {
  filters: null,
  searchtext: "",
  tableData: [],
  pageCount: 0,
  pageNumber: 1,
  perPage: 25,
  apiLoadingStatus: false,
  sortNode: "start_date",
  sortOrder: "DESC",
  tenantData: null,
};

const callRecordsData = createSlice({
  name: "callRecords",
  initialState,
  reducers: {
    setCallRecordsCache: (
      state,
      action: PayloadAction<{
        filters: CallRecordsFilters;
        searchtext: string;
        tableData: CallRecord[];
        pageCount: number;
        pageNumber: number;
        perPage: number;
        apiLoadingStatus: boolean;
        sortNode: string;
        sortOrder: string;
        tenantData?: TenantData;
      }>
    ) => {
      state.filters = action.payload.filters;
      state.searchtext = action.payload.searchtext;
      state.tableData = action.payload.tableData;
      state.pageCount = action.payload.pageCount;
      state.pageNumber = action.payload.pageNumber;
      state.perPage = action.payload.perPage;
      state.apiLoadingStatus = action.payload.apiLoadingStatus;
      state.sortNode = action.payload.sortNode;
      state.sortOrder = action.payload.sortOrder;
      if (action.payload.tenantData) {
        state.tenantData = action.payload.tenantData;
      }
    },

    // ✅ New reducer: update only tenantData
    setTenantDataRedux: (state, action: PayloadAction<TenantData>) => {
      state.tenantData = action.payload;
    },

    clearCallRecordsCache: (state) => {
      state.filters = null;
      state.searchtext = "";
      state.tableData = [];
      state.pageCount = 0;
      state.pageNumber = 1;
      state.perPage = 25;
      state.apiLoadingStatus = false;
      state.sortNode = "start_date";
      state.sortOrder = "DESC";
      // state.tenantData = null;
    },
  },
});

export const { setCallRecordsCache, clearCallRecordsCache, setTenantDataRedux } =
  callRecordsData.actions;

export default callRecordsData.reducer;
